export default __webpack_public_path__ + "static/media/Wright.b234dbd6.png";